import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUsb: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconUsb"><Path d="M10.75 8V5H9.25V8H10.75Z" fill="currentColor"/><Path d="M14.75 5V8H13.25V5H14.75Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M19 2H5V9.5H3V22H21V9.5H19V2ZM17.5 9.5V3.5H6.5V9.5H17.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconUsb;
